import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/partner-places`;

export const getMyPartnerPlaceInfo = async () => {
    const response = await axios.get(`${API_BASE_URL}/my`);
    return response.data;
};

export const searchPartnerPlaces = async (lastDistance = null, pageSize = 20) => {
    const params = { pageSize };
    if (lastDistance !== null) {
        params.lastDistance = lastDistance;
    }
    
    const response = await axios.get(API_BASE_URL, {
        params
    });
    return response.data;
};

export const getPartnerPlacePolicy = async (partnerPlaceId) => {
    const response = await axios.get(`${API_BASE_URL}/${partnerPlaceId}/policy`);
    return response.data;
};